import React from 'react';

import ContactImg from "../../assets/images/contact-img.png";
import BasariliMesaj from "../../assets/images/basarili-mesaj.png";

import { apiUnlockedPrm } from '../_App/Service';
import { useState } from 'react'

const ContactForm = () => {

    const [msj, setmsj] = useState(false);

    return (
        <div className="contact-area ptb-80">
            <div className="container">
                <div className="section-title">
                    <h2>Bize Mesaj Gönderebilirsiniz</h2>
                    <div className="bar"></div>
                    <p>Size en kısa sürede dönüş yapmaya çalışacağız</p>
                </div>

                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <img src={ContactImg} alt="konya yazılım firmaları iletişim" />
                    </div>

                    {msj == false ?
                        <div className="col-lg-6 col-md-12">
                            <form id="contactForm">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                placeholder="Ad Soyad"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="email"
                                                id="email"
                                                placeholder="Mail Adresi"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="number"
                                                id="number"
                                                placeholder="Telefon"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="subject"
                                                id="subject"
                                                placeholder="Konu"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <textarea
                                                name="text"
                                                id="text"
                                                cols="30"
                                                rows="5"
                                                placeholder="Mesajın"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-sm-12">
                                        <button type="submit" onClick={async () => {
                                            setmsj(true);
                                            var name = document.getElementById("name").value;
                                            var email = document.getElementById("email").value;
                                            var number = document.getElementById("number").value;
                                            var subject = document.getElementById("subject").value;
                                            var text = document.getElementById("text").value;


                                            const dt = {

                                                AdSoyad: name,
                                                MailAdresi: email,
                                                Telefon: number,
                                                Konu: subject,
                                                Mesaj: text,
                                                MisafirNo: "1",

                                            }

                                            await apiUnlockedPrm("PixelTalepEkle", dt).then((res) => {
                                                if (res.DogruMu == true) {

                                                  
                                                } else {
                                                  
                                                }
                                            })

                                        }} className="btn btn-primary">Mesaj Gönder</button>
                                    </div>
                                </div>
                            </form>
                        </div> :
                        <div className="col-lg-6 col-md-12">
                            <div className="col-lg-12 col-sm-12">
                            <img src={BasariliMesaj} alt="konya yazılım firmaları iletişim başarılı" />
                            </div>
                            <div className="col-lg-12 col-sm-12 center-pxl">
                                <button type="submit" onClick={async () => {
                                    setmsj(false);
                                }} className="btn btn-primary">Yeni Mesaj Gönder</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ContactForm;  